export const metadata = {
  metadata: {
    states: {
      active: 'WORKING',
      failed: 'DISABLED',
      inactive: 'STOPPED',
    },
    notifications: {
      changeErrorMsg: 'Metadata could not be updated.',
      changeSuccessMsg: 'Metadata updated',
      deleteErrorMsg: '{{count}} metadata could not be deleted',
      invalidIpAddressErrorMsg: 'Invalid IP address or hostname',
      saveErrorMsg: 'Metadata could not be created',
      saveSuccessMsg: 'Metadata created',
      startErrorMsg: '{{count}} metadata could not be started',
      stopErrorMsg: '{{count}} metadata could not be stopped',
    },
    noContent: {
      title: 'No Metadata Configured',
      subText: 'Add metadata to start your journey',
      btnText: 'ADD METADATA',
    },
    settings: {
      addMetadata: 'Add Metadata',
      auto: 'Auto',
      autoDetect: 'Auto-Detect',
      address: 'IP Address',
      classifyingCountry: 'Classifying Country',
      cotRelaying: 'CoT Relaying',
      countryCodes: 'Object Country Codes',
      countryCodesExplain: 'Max 6 delimited by a semicolon',
      countryCodingMethod: 'Country Coding Method',
      dataFormat: 'Data Format',
      decimation: 'Decimation',
      decimationMode: {
        byFactor: 'By Factor',
        dividedBy: 'Divided By',
        encoder: 'Encoder',
        factor: 'Factor',
        none: 'None',
        withEncoder: 'With Encoder',
        undecimated: 'Undecimated',
      },
      delta: 'Max AirCraft-SPI Delta',
      deltaExplain: '0 - 1000 ms',
      hdSDI: 'HD-SDI',
      hdSDIInput: 'HD-SDI Input',
      includedSecurityTags: 'Included UAS Security Tags',
      includedTags: 'Included UAS Tags',
      input: 'Input',
      klvFiltering: 'UAS KLV Tag Filtering',
      klvSecurityFiltering: 'UAS KLV Security Tag Filtering',
      metadataType: 'Metadata Type',
      missionId: 'Mission ID',
      missionIdInsertion: 'Mission ID Insertion',
      modal: {
        delete: {
          title: 'Delete this metadata?',
          title_plural: 'Delete {{count}} metadata?',
          bodyText: 'Metadata must be stopped before deleting.',
        },
        cotRelay: {
          addTitle: 'Add CoT Relay',
          editTitle: 'Edit CoT Relay',
        },
      },
      network: 'Network',
      port: 'Port',
      relayed: 'Relayed',
      security: {
        unclassified: 'UNCLASSIFIED',
        restricted: 'RESTRICTED',
        confidential: 'CONFIDENTIAL',
        secret: 'SECRET',
        topSecret: 'TOP SECRET',
      },
      securityClassification: 'Security Classification',
      securityDataInsertion: 'Security Data Set Insertion',
      sensorDiscovery: 'Sensor Discovery',
      serial: 'Serial',
      source: 'SOURCE',
      spiUid: 'SPI UID',
      st2110: 'ST 2110',
      st2110Short: '2110',
      tos: 'ToS',
      tosExplain: '0x00 - 0xFF',
      ttl: 'TTL',
      ttlExplain: '1 - 255',
      uas: {
        all: 'All',
        custom: 'Custom Set',
        minimum: 'Minimum Set',
        none: 'None',
      },
      unnamedMetadata: '(None)',
    },
    statistics: {
      rxBytes: 'RX Bytes',
      rxOKMessages: 'RX OK Messages',
      rxCorruptMessages: 'RX Corrupt Messages',
      klvBitrate: 'KLV Bitrate',
      sourceAddress: 'Source Address',
      rxSPIMessages: 'RX SPI Messages',
      rxAirCraftMessages: 'RX AirCraft Messages',
      generatedKLVMessages: 'Generated KLV Messages',
      generatedKLVBytes: 'Generated KLV Bytes',
      rxFilteredSPIMessages: 'RX Filtered SPI Messages',
      rxUasMessages: 'RX UAS Messages',
      invalidUasMessages: 'Invalid UAS Messages',
      addedMissionIDs: 'Added Mission IDs',
      updatedMissionIDs: 'Updated Mission IDs',
      addedSecuritySets: 'Added Security Sets',
      updatedSecuritySets: 'Updated Security Sets',
      sensorUIDs: 'Sensor UIDs',
      sourceTOS: 'Source TOS',
      tosChanges: 'TOS Changes',
      lastTosChange: 'Last TOS Change',
      sourceTTL: 'Source TTL',
      ttlChanges: 'TTL Changes',
      lastTtlChange: 'Last TTL Change',
      relayStatistics: 'Relay #{{count}} Statistics:',
      relayedBytes: 'Relayed Bytes',
      relayedMessages: 'Relayed Messages',
      relayingErrors: 'Relaying Errors',
      lastRelayError: 'Last Relay Error',
      lastRelayErrorOccurred: 'Last Error Occured',
    },
  },
};
